import { CheckCircle, Error as ErrorIcon } from "@mui/icons-material";
import { Box, Button, Container, Paper, Stack, ThemeProvider, Typography } from "@mui/material";
import { useEffect } from "react";
import { useSearchParams } from "react-router";
import { useSafeNavigateBack } from "../hooks/use-safe-navigate-back";
import { theme } from "../theme/theme";

export function IntegrationsConnectedPage() {
  const [searchParams] = useSearchParams();
  const navigateBack = useSafeNavigateBack("/configuration?tab=integrations");

  const provider = searchParams.get("provider");
  const status = searchParams.get("status");
  const message = searchParams.get("message");

  const isSuccess = status === "success";
  const providerName =
    provider === "slack"
      ? "Slack"
      : provider === "github"
        ? "GitHub"
        : provider === "linear"
          ? "Linear"
          : provider;

  useEffect(() => {
    // Auto-redirect to previous page after 3 seconds on success
    if (isSuccess) {
      const timeout = setTimeout(() => {
        navigateBack();
      }, 3000);
      return () => clearTimeout(timeout);
    }
  }, [isSuccess, navigateBack]);

  const handleGoToSettings = () => {
    navigateBack();
  };

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth="sm">
        <Stack alignItems="center" justifyContent="center" minHeight="100vh" spacing={3}>
          <Paper
            elevation={3}
            sx={{
              p: 4,
              maxWidth: 600,
              textAlign: "center",
              backgroundColor: "background.paper",
            }}
          >
            <Stack spacing={3} alignItems="center">
              {isSuccess ? (
                <CheckCircle
                  sx={{
                    fontSize: 64,
                    color: "success.main",
                  }}
                />
              ) : (
                <ErrorIcon
                  sx={{
                    fontSize: 64,
                    color: "error.main",
                  }}
                />
              )}

              <Typography variant="h4" component="h1" gutterBottom>
                {isSuccess ? `${providerName} Connected!` : `Connection Failed`}
              </Typography>

              <Typography variant="body1" color="text.secondary">
                {isSuccess
                  ? `You've successfully connected ${providerName} to your desplega.ai account. You can now use ${providerName} features.`
                  : message || `Failed to connect ${providerName}. Please try again.`}
              </Typography>

              {isSuccess && (
                <Typography variant="caption" color="text.secondary">
                  Redirecting to settings in 3 seconds...
                </Typography>
              )}

              <Box sx={{ pt: 2, width: "100%" }}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleGoToSettings}
                  size="large"
                >
                  Go to Integrations Settings
                </Button>
              </Box>
            </Stack>
          </Paper>
        </Stack>
      </Container>
    </ThemeProvider>
  );
}
